import { render, staticRenderFns } from "./WithdrawDetail.vue?vue&type=template&id=0699948b&scoped=true"
import script from "./WithdrawDetail.vue?vue&type=script&lang=js"
export * from "./WithdrawDetail.vue?vue&type=script&lang=js"
import style0 from "./WithdrawDetail.vue?vue&type=style&index=0&id=0699948b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699948b",
  null
  
)

export default component.exports